<template>
<div>
    <!-- <ConditionBox style="margin-bottom: 10px;" :config="myConfig"  @conditionAction="conditionAction" :isPop="isPop" :dictData="dictData"> </ConditionBox> -->
    <!-- <Row type="flex" justify="end" :gutter="8">
       <Col>
           <Toolbar :config="myToolConfig"  @doAction="doBatchAction" tooltype="batch" :moduleMethod="globalConfig.moduleMethod" ></Toolbar>
       </Col>
        <Col v-if="myConfig.gridType === 'billGrid'">
            <Tooltip :content="modulecode" placement="left">
                <Icon size="32" color="#ffff3a" type="ios-information-circle-outline" />
            </Tooltip>
        </Col>
    </Row> -->
    <Table ref="table"  style="margin-top: 5px;" :loading="loading" :size="myConfig.tableSize"  :stripe="myConfig.showStripe" :border="myConfig.showBorder" :height="currentHeight":show-header="myConfig.showHeader" :columns="tableColumns"  :data="data" @on-sort-change="sortChagne"  @on-current-change="singleChagne":highlight-row="true" @on-row-dblclick="dbclick"  @on-row-click="click">

    </Table>
    <div  v-if="myConfig.showPage" style="margin: 10px;overflow: hidden">
        <div style="float: right;">
          <Page :total="myConfig.pageConfig.total_results"  :current="myConfig.pageConfig.page_no" :page-size="myConfig.pageConfig.page_size" :page-size-opts="myConfig.pageConfig.pageSizeList"  @on-page-size-change="changePageSize" @on-change="changePage"  show-total show-elevator show-sizer></Page>
        </div>
    </div>
    <slot name="footer"></slot>
</div>
</template>
<script>
import Base from './basegrid.vue';
export default {
    name: 'ocmviewgrid',
    extends: Base,
    data () {
        return {
            myConfig:{
                resources:'',
                method:'',
                response:'',
                searchParam:null,
                readOnly:true,
                multiSelect:true,
                bindSearchParam:'ph_key',
                showAll:false,
                tdHeight: 30
            },
            editRowFlag:false,
            singleData:{}
        };
    },
    methods: {
        customInit() {
            if (this.isPop) {
                if (this.myConfig.multiSelect) {
                    this.myConfig.showCheckBox = true;
                }
            }
           
            if (this.myConfig.gridType === 'billGrid') {
                this.getModuleMethod();
            }
            if (this.myConfig.tableSize ==='' || this.myConfig.tableSize ===undefined) {
                this.myConfig.tableSize = 'default';
            }
            
        },
        getSearchParam() {
            let searchParam = this.$Method.copy(this.myConfig.searchParam);
            if (!searchParam) {
                searchParam = {};
            }
            searchParam = Object.assign({},searchParam,this.conditionSearchParam);
            
            if (this.showPage) {
                searchParam.page_no = this.myConfig.pageConfig.page_no;
                searchParam.page_size = this.myConfig.pageConfig.page_size;
            }
            
            return searchParam;

        },
        setWhereParam(obj) {
            this.conditionSearchParam = this.$Method.copy(obj);
        },
        valueChanged (para) {
            let reData = [];
            let self = this;
            self.synchroPost(self.myConfig.resources,self.myConfig.method,para,function(data) {
                if (data && data[self.myConfig.response]) {
                    reData = data[self.myConfig.response];
                }  
            },null);
            return reData;
        },

        refurbish() {
            this.loading = true;
            let self = this;
            this.singleData = {};
            self.synchroPost(self.myConfig.resources,self.myConfig.method,self.getSearchParam(),function(data) {
                if (data && data[self.myConfig.response]) {
                    if (self.myConfig.showAll) {
                        if (self.myConfig.rowAll) {
                            data[self.myConfig.response].splice(0,0,self.myConfig.rowAll);
                        }
                    }
                    self.data = data[self.myConfig.response];
                }
                if (data.total_results !== undefined) {
                    self.myConfig.pageConfig.total_results= Number(data.total_results);
                }
                self.loading = false;   
            },function() {
                self.loading = false;
            });
        },
        changePage (para) {
            this.myConfig.pageConfig.page_no = para;
            this.refurbish();
        },
        changePageSize (para) {
            this.myConfig.pageConfig.page_size = para;
            this.refurbish();
        },
        sortChagne (para) {
            let order_field = '';
            let order_direction = '';
            if (this.config.searchParam.order_field) {
                order_field = this.config.searchParam.order_field+','+ para.key;
            } 
            if (this.config.searchParam.order_direction) {
                order_direction = this.config.searchParam.order_direction+','+ para.order;
            } 
            this.myConfig.searchParam.order_field = order_field;
            this.myConfig.searchParam.order_direction = order_direction;
            this.refurbish();
        },
        setColumnRendel(column) {
            column.editing = false;
        },
        singleChagne(currentRow,oldCurrentRow) {
            this.singleData = {};
            this.singleData.currentRow= currentRow;
            this.singleData.oldCurrentRow= oldCurrentRow;
        },
        removeRow(index) {
            this.data.splice(index, 1);
        },
        doBatchAction(obj) {
            if (obj.name !== 'addData') {
                let data = this.$refs.table.getSelection();
                if (data.length  === 0) {
                    this.alert('请至少选择一行');
                    return;
                }
                obj.data= data; 
            }
            this.$emit('doAction', obj);
        },
        add() {
            let obj = {};
            obj.name ='addData';
            this.$emit('doAction', obj);
        },
        getSelection() {
            return  this.$refs.table.getSelection();
        }
    },
    mounted () {
        
    }
};
</script>


// WEBPACK FOOTER //
// src/components/grid/ocmviewgrid.vue